<script>
    import { possArray } from "./card_actions";
    import { state, res } from "./stores";
    import Select from 'svelte-select/Select.svelte';
    import { boxSetupCounts, isMainBox } from "./game.js";

    // Basic principle:
    // All sets are listed here
    // selectedCommons and mixinSets are populated/updated based on below
    // 

    let commonsBoxes = ['Core Box'];
    export let captains = [];
    let lastCaptains = [];

    $: updateCaptains(captains);

    $: if(commonsBoxes){
        console.log(commonsBoxes);
    }

    function isFullCommons(box){
        // in future do it via actual flag
        // for now, heuristically based on deck numbers
        box = $res.sets.find(s => s.name == box);
        if(!box){
            return false;
        }
        if(box.type == 'Base') return true;
        return false;
    }

    function allModules(){
        let modules = [];
        for(let s of $res.sets){
            for(let m of s.modules){
                if(m && !modules.includes(m)) modules.push(m);
            }
        }
        return modules;
    }

    function getNecessaryModules(boxes){
        let modulesToAdd = [];
        let alreadyThereModules = [];
        let toReturn = [];
        for(let b of boxes){
            if(b.value) b = b.value;
            toReturn.push(b);
            if(allModules().includes(b)){
                alreadyThereModules.push(b);
                continue; // Don't add already selected modules
            }
            let box = $res.sets.find(s => s.name == b);
            if(box){
                for(let m of box.modules){
                    if(!modulesToAdd.includes(m) && !alreadyThereModules.includes(m)) modulesToAdd.push(m);
                }
            }
        }
        return [...toReturn, ...modulesToAdd];
    }

    function getBoxesForCaptains(captains){
        let boxes = [];
        let defaultCommons = 'Core Box';
        for(let c of captains){
            let box = $res.sets.find(s => s.decks.includes(c));
            if(box){
                if(!boxes.includes(box.name)) boxes.push(box.name);
            }
            // if !box then this deck isn't in any published box
        }
        if(!boxes.some(b => isFullCommons(b))) boxes.push(defaultCommons); // So we have something base at least
        return boxes;
    }

    function updateCaptains(captains){
        for(let i = 0; i < 2; i++){
            if(lastCaptains[i] != captains[i]) break;
            if(i == 1) return; // both the same, so don't update (otherwise edits to $state trigger updates)
        }
        lastCaptains = [...captains]; // for next time
        commonsBoxes = getBoxesForCaptains(captains);
        updateBoxes(commonsBoxes);
        /*if(!commonsBoxes || !commonsBoxes.every(b => newBoxes.includes(b))){
            // i.e. only update if there's significant change
            // maybe not??
            commonsBoxes = newBoxes; // This will trigger an update of the full sets below too
            updateBoxes(commonsBoxes);
        }*/
    }

    function updateBoxes(_){
        let selectedCommons = [];
        let mixinSets = {};
        let modules = [];
        if(!commonsBoxes) return;
        commonsBoxes = getNecessaryModules(commonsBoxes);
        for(let c of commonsBoxes){
            if(c.value) c = c.value;
            if(isFullCommons(c)){
                selectedCommons.push(c);
            }else if(allModules().includes(c)){
                modules.push(c);
            }else{
                mixinSets[c] = true;
            }
        }
        $res.selectedCommons = selectedCommons;
        $res.mixinSets = mixinSets;
        $res.modules = modules;
    }

    // Rules default for setup junking/destroying, shown alongside the overrides
    $: mainBoxes = [...$res.selectedCommons, ...Object.keys($res.mixinSets || {})].filter(b => isMainBox(b, $res.sets));
    $: autoRemoval = boxSetupCounts(mainBoxes.length);
    const removalOptions = [0, 1, 2, 3, 4, 5];

    function getAllItems(){
        let items = $res.sets.map(s => s.name);
        items.push(...allModules()/*.map(m => {
            return {
                label: `${m} module`,
                value: m
            }
        })*/);
        return items;
    }

    
    

</script>

<div>
    Box(es)/expansion(s)/module(s) to use:
    <div class="multiselect"><Select containerStyles="color: black;" bind:value={commonsBoxes} items={getAllItems()} multiple={true} clearable={false} on:clear={e => {updateBoxes(commonsBoxes)}} on:change={e => {updateBoxes(commonsBoxes)}}/></div>
    <div>
        Before the game, from the top of each market deck:
        junk <select bind:value={$res.setupJunk}>
            <option value={null}>{autoRemoval.junk} (rules default)</option>
            {#each removalOptions as n}<option value={n}>{n}</option>{/each}
        </select>
        then destroy <select bind:value={$res.setupDestroy}>
            <option value={null}>{autoRemoval.destroy} (rules default)</option>
            {#each removalOptions as n}<option value={n}>{n}</option>{/each}
        </select>
        <span style="opacity: 0.7;">({mainBoxes.length} main box{mainBoxes.length == 1 ? '' : 'es'}: destroy 1 per main box beyond the first; small expansions don't count)</span>
    </div>

</div>

<style>
    .multiselect {
		--multiItemActiveBG: blue;
		--multiItemActiveColor: white;
		--multiItemBG: lightgrey;
		--itemHoverBG: blue;
		--itemHoverColor: white;
		--itemColor: black;
		display: inline-block;
		vertical-align: middle;
	}

</style>